import FileUploader from '@/services/files/FileUploader'

export const onInvalidSubmit = () => {
  const el = document.querySelector(`.border-red-500`)
  if (el) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest',
    })
  }
}

/**
 * Upload all files in the object and replace them with the media object iri
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const handleFileUpload = async (object: any) => {
  const uploadPromises = Object.keys(object).map(async (fieldName) => {
    if (object[fieldName] instanceof File) {
      const response = await FileUploader.uploadFile(object[fieldName])
      object[fieldName] = response['@id']
    }
  })
  await Promise.all(uploadPromises)
  return object
}
